module.exports = __webpack_public_path__ + "img/f3.dcfeeee8.png";